import React from "react";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";


class WikiPageDetailHeader extends React.Component {
    render() {
        return(
            <Stack>
                <Typography level={'h4'}>
                    {this.props.wikiPage.title}
                </Typography>
            </Stack>
        )
    }
}

export default WikiPageDetailHeader